module.exports = __webpack_public_path__ + "static/vf_wpants_core.6fc8c0fc.svg";